import { consumeBookingSearch } from "@/lib/bookingSearch/consume"
import { BookingSearchContainer } from "@/lib/bookingSearch/container"
import { BookingSearchContext } from "@/lib/bookingSearch/context"
import type { Businesses } from "@/lib/businesses"
import type { Caching } from "@/lib/caching"
import type { Geolocation } from "@/lib/geolocation"
import type { Mirror } from "@/lib/mirror"
import type { Services } from "@/lib/services"

export namespace BookingSearch {
  export type ContextData = {
    hasAddress: boolean
    perform: Functions.Perform
    processing: string | undefined
    results: Results
  }

  export type BusinessMirror = Mirror<Businesses.Business>

  export type Results = {
    businesses: Cache.Payload
  }

  export type Timeframe = `next 7 days` | `next 3 days`

  export const Container = BookingSearchContainer
  export const Context = BookingSearchContext

  export const consume = consumeBookingSearch

  export namespace Cache {
    export const expiry = 1000 * 60 * 5 // 5 minutes

    export type Store = Record<
      Services.Option,
      Record<Geolocation.Position, Record<Geolocation.DistanceKey, Payload>>
    >

    export type Data = BusinessMirror

    export type KeyData = {
      distance: Geolocation.DistanceOption
      position: Geolocation.Position
      service: Services.Option
    }

    export type Keys = [
      `bookingSearch`,
      Geolocation.Position,
      Geolocation.DistanceKey,
      Services.Option
    ]

    export type Payload = Caching.Payload<Data>
  }

  export namespace Functions {
    export type Perform = () => Promise<Results>
  }
}
